import axios from "axios";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, withCredentials: true });

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && !err.config.url.includes("/auth/login") && !err.config.url.includes("/finance-lock")) {
      if (window.location.pathname !== "/login") window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;

export async function exportPdf(filename, rows, cols, title, subtitle = "", summary = []) {
  const val = (c, r) => (c.money ? inr(r[c.key]) : c.pct ? `${r[c.key] ?? 0}%` : r[c.key]);
  const res = await api.post("/reports/pdf", { filename: filename.replace(/\.pdf$/, ""), title, subtitle, summary, columns: cols.map((c) => c.label), rows: rows.map((r) => cols.map((c) => val(c, r))) }, { responseType: "blob" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
  a.download = filename.endsWith(".pdf") ? filename : `${filename}.pdf`;
  a.click();
}

export function exportCsv(filename, rows, cols) {
  const esc = (v) => `"${String(v ?? "").replace(/"/g, '""')}"`;
  const lines = [cols.map((c) => esc(c.label)).join(","), ...rows.map((r) => cols.map((c) => esc(r[c.key])).join(","))];
  const blob = new Blob([lines.join("\n")], { type: "text/csv" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  a.click();
}
